import { Button, Checkbox } from '@mgdlead/ui';

/**
 * "Selecionar todos" das listas de escolha de grupos (pedido do dono, 11/10/2026: "quando
 * selecionar grupos deveria ter como selecionar todos de uma única vez").
 *
 * Tri-state, e sempre sobre o que está VISÍVEL (o que a busca deixou passar):
 *  - nenhum ou alguns marcados → um toque marca todos os visíveis;
 *  - todos marcados → um toque desmarca os visíveis.
 * "Limpar seleção" zera tudo, inclusive o que a busca escondeu — é o botão de recomeçar.
 *
 * Mora em `features/monitor` só porque é o escopo deste lote; o lugar certo, quando houver
 * um terceiro uso, é a biblioteca `@mgdlead/ui`.
 */
export interface SelectAllBarProps {
  /** Quantos itens marcáveis estão visíveis agora. */
  visible: number;
  /** Quantos desses visíveis estão marcados. */
  selectedVisible: number;
  /** Quantos estão marcados no total (inclui os que a busca escondeu). */
  selectedTotal: number;
  /** A busca está filtrando a lista? Muda o rótulo para não prometer "todos" sem ser. */
  filtered: boolean;
  disabled?: boolean;
  onSelectVisible: () => void;
  onUnselectVisible: () => void;
  onClear: () => void;
}

export function SelectAllBar({
  visible,
  selectedVisible,
  selectedTotal,
  filtered,
  disabled = false,
  onSelectVisible,
  onUnselectVisible,
  onClear,
}: SelectAllBarProps) {
  if (visible === 0) return null;

  const todos = selectedVisible === visible;
  const alguns = selectedVisible > 0 && !todos;
  const rotulo = filtered
    ? visible === 1
      ? 'Selecionar o encontrado'
      : `Selecionar os ${visible} encontrados`
    : 'Selecionar todos';

  return (
    <div className="flex flex-wrap items-center justify-between gap-2 rounded-lg border border-border px-3 py-1.5">
      <Checkbox
        label={rotulo}
        checked={todos}
        indeterminate={alguns}
        disabled={disabled}
        onChange={() => (todos ? onUnselectVisible() : onSelectVisible())}
      />
      <span className="flex items-center gap-2">
        <span className="nums text-xs text-muted-foreground" aria-live="polite">
          {selectedVisible} de {visible} {visible === 1 ? 'selecionado' : 'selecionados'}
        </span>
        {selectedTotal > 0 ? (
          <Button variant="ghost" size="sm" disabled={disabled} onClick={onClear}>
            Limpar seleção
          </Button>
        ) : null}
      </span>
    </div>
  );
}
